/**
 * Seller Product Details
 */

// React
import React, {FunctionComponent, useContext, useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';

// Context
import AuthContext, {AuthConsumer} from '../../authContext';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  getProductAction,
  getProductVariantsActions,
  getCategoriesAction,
} from './actions';
import {Store} from '../../redux/reducers';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectProductsVariantListByProductId,
  makeSelectProductsVariantListCount,
  makeSelectProduct,
  makeSelectCategoriesList,
  makeSelectCategoryLoading,
} from './selectors';
import {makeSelectSkusInventoryList} from '../warehouses/selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/variantList';
import Details from './components/detail';
import {GetInventoryFlowRequestBuilder} from 'client-sdk/src/skus/skus';
import Client from 'client-sdk/src/client';
import Modal from '../../components/Modal';
import Can from '../../components/Can';
import CSV from './components/csv';
import ReportList from '../warehouseInventory/components/reportList';

// UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Paper,
  CircularProgress,
  Button,
  Grid,
  IconButton,
  InputBase,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';

// Helper
import {removeEmptyValueObject, flattenObject} from '../../utils/helpers';
import handleError from '../../utils/handleError';

// Type
import {Props, SelectorPropsVariants} from './interfaces';
import {useForm} from 'react-hook-form';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& #showFilter .MuiInput-underline::before, & #showFilter .MuiInput-underline::after': {
        borderBottom: '2px solid #DFA01F !important',
      },
    },
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    // searchBox: {
    //   display: 'flex',
    //   position: 'relative',
    //   backgroundColor: theme.palette.common.white,
    //   padding: '10px 0',
    //   borderRadius: '4px',
    //   boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    // },
    // input: {
    //   display: 'flex',
    //   marginLeft: theme.spacing(1),
    //   flex: 3,
    //   '@media (max-width: 768px)': {
    //     fontSize: '12px',
    //   },
    // },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    title: {
      fontWeight: 500,
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      paddingTop: '8px',
      paddingRight: '24px',
      paddingBottom: '8px',
      paddingLeft: '50px',
      marginLeft: '-40px',
    },
    cardContent: {
      paddingLeft: '14px',
    },
    card: {
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px',
    },
  })
);

type Inputs = {
  'customerNationalCode.contains': string;
};

const SellerProductDetail: FunctionComponent<Props> = (
  props: Props
): React.ReactElement => {
  const {register, handleSubmit, reset} = useForm<Inputs>();
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const [reportModal, setReportModal] = useState(false as boolean);
  const [reportId, setReportId] = useState(null as any);
  const [reportLoading, setReportLoading] = useState(false as boolean);
  const [reportList, setReportList] = useState<any>(null);
  const [reportFilters, setReportFilters] = useState<any>({
    page: 0,
    size: 10,
  });
  const [openSizeReport, setOpenSizeReport] = React.useState(false as boolean);
  const [reportCsvData, setReportCsvData] = useState([]);

  const [inventoryFilters, setInventoryFilters] = useState({
    page: 0,
    size: 10,
  } as any);
  const authContext = useContext(AuthContext);
  const [parcelItemsModal, setParcelItemsModal] = useState(false as boolean);

  const [selectedItem, setSelectedItem] = useState<any>(null);

  const token = localStorage.getItem('token') || '';

  const urlParams = useParams();

  const onSubmit = (filtervalues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filtervalues),
      page: 0,
      size: 10,
    });
    reset({});
  };

  useEffect(() => {
    getProduct();
    getCategories();
    getProductVariants();
  }, [filtersValues]);

  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const getProduct = () => {
    const {page, size} = filtersValues;
    const {partnerId} = props.match.params;
    props.productDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: {equals: partnerId},
      id: urlParams.id,
      page,
      size,
    });
  };

  const fetchReportList = async (id: number, args: Record<string, any>) => {
    try {
      setReportLoading(true);
      const request = new GetInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject(reportFilters)),
          ...args,
        })
        .build();
      const client = new Client(token);
      const {data} = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err);
    } finally {
      setReportLoading(false);
    }
  };

  const getCategories = () => {
    const {page, size} = filtersValues;
    const {partnerId} = props.match.params;
    props.categoriesDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: {equals: partnerId},
      page,
      size,
    });
  };

  const getProductVariants = () => {
    const {page, size} = filtersValues;
    const {partnerId} = props.match.params;
    props.productVariantsDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: {equals: partnerId},
      id: urlParams.id,
      page,
      size,
    });
  };

  const findSelectedItem = (id: number) => {
    const findSelectSku = props.skusInventoryList.find(
      (el: any) => el.id === id
    )!;
    setSelectedItem(findSelectSku);
  };

  const handleReport = (id: number) => {
    setReportModal(true);
    setReportId(id);
    fetchReportList(id);
    // props.getParcelsDispatch({'skuId.equals': id, size: 150});
    findSelectedItem(id);
  };

  const handleCloseReportModal = () => {
    setReportModal(false);
    setFiltersValues({
      page: 0,
      size: 10,
    });
    setReportList(null);
    setReportCsvData([]);
  };

  const handleGetParcelInventory = (id: number) => {
    setParcelItemsModal(true);
    setInventoryFilters((prevState: Record<string, any>) => ({
      ...prevState,
      'parcelId.equals': id,
    }));
    getParcelInventoryRequest({'parcelId.equals': id});
  };

  const getParcelInventoryRequest = (arg: Record<string, any>) => {
    props.getParcelInventoryItems({...inventoryFilters, ...arg});
  };

  const handleChangeSizeReportList = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    setReportFilters({...reportFilters, page: 0, size: event.target.value});
    fetchReportList(reportId, {...reportFilters, size: event.target.value});
  };

  const handleChangeReportPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setReportFilters({...reportFilters, page: page - 1});
    fetchReportList(reportId, {...reportFilters, page: page - 1});
  };

  return (
    <div className={classes.root}>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            padding: '5px 2px',
            width: '100%',
            borderRadius: '0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2" className={classes.title}>
              {`مشخصات کالا`}
              {props.product.name.concat(' - ', props.product.id)}
            </Typography>
          </div>
        </Paper>
      </Grid>

      <Grid container spacing={2} style={{marginTop: '8px'}}>
        <Grid item xs={3} lg={3} md={3}>
          <Details product={props.product} />
        </Grid>

        <Grid item lg={9} md={9}>
          <Card className={classes.card} style={{padding: '14px 0  0'}}>
            <CardHeader
              avatar={
                <Typography className={classes.typographyCards}>
                  {`لیست تنوع کالا`}
                  {props.product.name.concat(' - ', props.product.id)}
                </Typography>
              }
            />

            <CardContent style={{margin: '15px 0  0', padding: '0'}}>
              <Grid item xs={12}>
                {props.loading ? (
                  <div className={classes.loading}>
                    <CircularProgress />
                  </div>
                ) : (
                  props.productsVariantsList && (
                    <List
                      handleReport={handleReport}
                      data={props.productsVariantsList}
                      productName={props.product.name}
                      handleOpenConfirmDisable={() => {}}
                      handleOpen={() => {}}
                      changeStatus={() => {}}
                    />
                  )
                )}
              </Grid>
              <Grid
                md={12}
                container
                justifyContent="space-between"
                style={{marginTop: '10px', padding: '20px'}}
              >
                <Grid id="showFilter" item xs={6} sm={6}>
                  {props.productsVariantsList && (
                    <FormControl
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                        {' '}
                        تعداد نمایش در هر صفحه:
                      </div>
                      <Select
                        open={openSize}
                        onClose={handleCloseSelect}
                        className={classes.showCount}
                        onOpen={() => setOpenSize(true)}
                        value={filtersValues.size}
                        onChange={handleChangeSizePage}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Grid>
                <Grid container item md={6} direction="row-reverse">
                  {props.productsVariantsList && (
                    <Pagination
                      count={Math.ceil(
                        props.productVariantListCount / filtersValues.size
                      )}
                      color="secondary"
                      page={filtersValues.page + 1}
                      onChange={handleChangePage}
                    />
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Modal
        maxWidth="md"
        onClose={handleCloseReportModal}
        open={reportModal}
        title={
          <div style={{textAlign: 'right'}}>
            <span>{`تاریخچه ورود و خروج کالای ${props.product.name}`}</span>
          </div>
        }
        content={
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {reportLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <React.Fragment>
                  <Grid item xs={12}>
                    <div style={{textAlign: 'left'}}>
                      <Can
                        role={authContext.user.role}
                        perform="skus:downloadCSV"
                        yes={() => (
                          <CSV
                            loading={reportCsvLoading}
                            handleCreateCSV={fetchReportCsv}
                            data={reportCsvData}
                          />
                        )}
                      />
                    </div>
                    <Box mb={3} />
                  </Grid>
                  <ReportList
                    data={reportList?.content}
                    handleSelect={handleGetParcelInventory}
                  />
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSizeReport}
                  onClose={() => setOpenSizeReport(false)}
                  onOpen={() => setOpenSizeReport(true)}
                  value={reportFilters.size}
                  onChange={handleChangeSizeReportList}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(
                  reportList?.totalElements / reportFilters.size
                )}
                color="secondary"
                page={reportFilters?.page + 1}
                onChange={handleChangeReportPage}
              />
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorPropsVariants>({
  skusInventoryList: makeSelectSkusInventoryList(),

  product: makeSelectProduct(),
  categoriesList: makeSelectCategoriesList(),
  productsVariantsList: makeSelectProductsVariantListByProductId(),
  productVariantListCount: makeSelectProductsVariantListCount(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  categoryLoading: makeSelectCategoryLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    productDispatch: (payload: Object) => dispatch(getProductAction(payload)),
    categoriesDispatch: (payload: Object) =>
      dispatch(getCategoriesAction(payload)),
    productVariantsDispatch: (payload: Object) =>
      dispatch(getProductVariantsActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
// @ts-ignore
export default compose(withConnect)(SellerProductDetail);
